import useUser from "../../hooks/useUser";
import { useState } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from "../../admin/components/Toast";
const ResetPasswordPage = ()=>{
    const [searchParams] = useSearchParams();
    const [password,setNewPassword] = useState("");
    const {ResetPassword} =useUser()
    const navigate= useNavigate();
    const {addToast} = useToast();

    const handlePasswordReset = async(e)=>{
        e.preventDefault();
        const token = searchParams.get("token");
        if (!token)
        {
            navigate("/status", { state: { statusCode: 403 } });
            return;
        }
        const new_password = password;
        try {
            const data = await ResetPassword(token, new_password);
            addToast("Password reset successfully", "success");
            navigate("/login");
            return;
        } catch (error) {
            console.log("error resetting password", error);
        }
    }


return (
        <div className="max-w-md mx-auto mt-16 p-6 border border-gray-300 bg-white rounded shadow">
        <form className="space-y-4">
            <label>
                New Password:
                <input onChange={(e)=>setNewPassword(e.target.value)} type="password" name="new_password" required />
            </label>
            <button onClick={handlePasswordReset} className='w-full py-2 px-4 bg-blue-600 text-white rounded hover:bg-blue-700' type="submit">Reset Password</button>
        </form>
    </div>)
}


export default ResetPasswordPage;